import Constant from "../constants";
import { mainWrapper } from "./main";

const ContentService = {
    faq,
    aboutUs,
    contactUs,
    contactUsForm,
    termsConditions,
    privacyPolicy,
    carrerList,
    partnership,
    hire,
    verticals,
    feedback,
    feedbackForm,
    technolgy,
};

function faq() {
    return mainWrapper.get(Constant.host + "/faq");
}

function aboutUs() {
    return mainWrapper.get(Constant.host + "/about-us");
}

function contactUs() {
    return mainWrapper.get(Constant.host + "/contact-us");
}

function contactUsForm(params) {
    return mainWrapper.post(Constant.host + "/contact-us/add",params);
}

function termsConditions() {
    return mainWrapper.get(Constant.host + "/pages/terms-condition");
}

function privacyPolicy() {
    return mainWrapper.get(Constant.host + "/pages/privacy-policy");
}

function carrerList() {
    return mainWrapper.get(Constant.host + "/careers");
}

function partnership() {
    return mainWrapper.get(Constant.host + "/partners-with-us");
}

function hire() {
    return mainWrapper.get(Constant.host + "/hire-resources");
}

function verticals() {
    return mainWrapper.get(Constant.host + "/verticals");
}

function feedback() {
    return mainWrapper.get(Constant.host + "/feedback/page");
}

function feedbackForm(params) {
    return mainWrapper.post(Constant.host + "/feedback",params);
}

function technolgy() {
    return mainWrapper.get(Constant.host + "/technologies");
}

export default ContentService;
